import ComponentColor from 'src/types/ItemColor'
import useProductPage from './useProductPage'

const useComponentColor = () => {
  const page = useProductPage()

  return page.componentColor || ComponentColor.blue
}

export default useComponentColor
